<ng-container *ngIf="!(submitted$ | async) && (hubspotData$ | async) as hubspotData">
    <ng-container *ngIf="reactiveFormData$ | async as reactiveForm">
        <form
            [formGroup]="reactiveForm"
            id="{{ currentHash$ | async }}"
            class="hs-custom-form"
            snInViewport
            (inViewportChange)="onInViewportChange($event)"
        >
            <fieldset>
                <ng-container *ngFor="let group of hubspotData.formFieldGroups">
                    <div class="row" [ngClass]="{ 'two-column': group.fields.length > 1 }">
                        <ng-container
                            *ngFor="let control of group.fields"
                            daDynamicField
                            [control]="control"
                            [reactiveFormData]="reactiveForm"
                            [formId]="currentHash$ | async"
                        >
                        </ng-container>
                        <ng-container *ngIf="getRichTextWithoutTags(group.richText) as richtext">
                            <p>{{ richtext }}</p></ng-container
                        >
                    </div>
                </ng-container>
                <ng-container *ngIf="legalConsents$ | async as legalConsent">
                    <da-form-field-legal-consent
                        [consentData]="legalConsent"
                        [group]="reactiveFormData$ | async"
                        [formId]="currentHash$ | async"
                    ></da-form-field-legal-consent>
                </ng-container>
            </fieldset>
            <p *ngIf="hasMissingRequiredFields$ | async">
                <span class="error-msg">{{ 'hubspot.missingRequiredFields' | translate }}</span>
            </p>
            <p class="formsubmit">
                <button type="submit" da-button themeType="Primary" (click)="onSubmit($event)" [innerHTML]="'hubspot.submitText' | translate">
                </button>
            </p>
        </form>
    </ng-container>
</ng-container>

<ng-container *ngIf="(submitted$ | async) && (inlineMessage$ | async) as confirmation">
    <div class="confirmmessage">
        <div class="left"></div>
        <div class="right" [innerHtml]="confirmation"></div>
    </div>
</ng-container>

<ng-container *ngIf="errorResponse$ | async as errorResponse">
    <div class="errormessage">
        <div class="left"></div>
        <div class="right" [innerHtml]="errorResponse"></div>
    </div>
</ng-container>
